// extracted by mini-css-extract-plugin
export default {"thead":"thead__rXvLD","heading":"heading__NrULF","label":"label__HPpxF"};